import request from '@/axios'
import type { UserType, UserLoginType } from './types'

export const loginApi = (data: UserLoginType): Promise<IResponse<UserType>> => {
  return request.post({
    url: '/admin/login/official',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 退出登录接口
export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/admin/login/official/logout' })
}

// 无用接口
export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminMenuRoleApi = (params: {
  status: boolean
}): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/admin/menu/official/getAll', params })
}

// 无用接口
export const getTestRoleApi = (): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2' })
}

/** 修改密码 */
export const updatePasswordApi = (data: {
  oldPassword: string
  newPassword: string
  confirmPassword: string
}): Promise<IResponse<void>> => {
  return request.post({ url: '/admin/official/user/updatePassword', data })
}
